<div class="history-diagram-container">
    <div class="row dynamicChart-container"
        *ngFor="let listOfTaskActionsHistoryDetails of getOneQmsTaskActionsHistoryVwDetails; let idx = index;">
        <div class="taskRefNo-msg-container" *ngIf="idx!=0">
            <span
                *ngIf="getOneQmsTaskActionsHistoryVwDetails[idx].taskRefNo!=getOneQmsTaskActionsHistoryVwDetails[idx-1].taskRefNo">
                Permanent number has been generated ({{ listOfTaskActionsHistoryDetails.taskRefNo }})
            </span>
        </div>
        <div class="col-sm-2">
            <div class="circle">
                <span class="currentStatus-container">{{ listOfTaskActionsHistoryDetails.currentStatus }}</span>
            </div>
        </div>
        <div class="col-sm-2 section2-container">
            <div class="userFullName-container">{{ listOfTaskActionsHistoryDetails.actionUserFullname }}</div>
        </div>
        <div class="col-sm-3 section3-container">
            <span>
                {{ listOfTaskActionsHistoryDetails.operation }}, {{ listOfTaskActionsHistoryDetails.actionPerformedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss') }}
            </span><br>
            <span>
                {{ listOfTaskActionsHistoryDetails.actionPerformerComments }}
            </span>
        </div>
    </div>
</div>